module.exports = __webpack_public_path__ + "static/media/lock.b3c3d2bd.svg";